/* eslint-disable no-eval */
/* eslint-disable consistent-return */
import { getCookie } from '../../utils/cookies';

export default async function alertLogger(calledFrom = '', extraData = {}) {
  try {
    let isPrivateMode = false;

    // const getAllCookies = () =>
    //   document.cookie.split('; ').reduce((cookies, cookieStr) => {
    //     const [key, value] = cookieStr.split('=');
    //     cookies[decodeURIComponent(key)] = decodeURIComponent(value);
    //     return cookies;
    //   }, {});

    const getSelectedCookies = () => {
      const cookieString = document.cookie;
      const cookieArray = cookieString.split('; ');
      const selectedKeys = ['prc', 'ssoid', 'ticketid'];

      const result = { __length: cookieString.length };

      // eslint-disable-next-line no-restricted-syntax
      for (const cookie of cookieArray) {
        const [key, value] = cookie.split('=');
        if (selectedKeys.includes(key)) {
          result[key] = decodeURIComponent(value);
        }
      }

      return result;
    };

    const detectIncognito = async () =>
      new Promise((resolve, reject) => {
        let browserName = 'Unknown';
        const __callback = isPrivate => {
          resolve({
            isPrivate,
            browserName,
          });
        };
        const identifyChromium = () => {
          const ua = navigator.userAgent;
          if (ua.match(/Chrome/)) {
            if (navigator.brave !== undefined) {
              return 'Brave';
            } else if (ua.match(/Edg/)) {
              return 'Edge';
            } else if (ua.match(/OPR/)) {
              return 'Opera';
            }
            return 'Chrome';
          }

          return 'Chromium';
        };
        const assertEvalToString = value => value === eval.toString().length;
        const isSafari = () => {
          const v = navigator.vendor;
          return (
            v !== undefined &&
            v.indexOf('Apple') === 0 &&
            assertEvalToString(37)
          );
        };
        const isChrome = () => {
          const v = navigator.vendor;
          return (
            v !== undefined &&
            v.indexOf('Google') === 0 &&
            assertEvalToString(33)
          );
        };
        const isFirefox = () =>
          document.documentElement !== undefined &&
          document.documentElement.style.MozAppearance !== undefined &&
          assertEvalToString(37);
        const isMSIE = () =>
          navigator.msSaveBlob !== undefined && assertEvalToString(39);
        /**
         * Safari (Safari for iOS & macOS)
         **/
        // eslint-disable-next-line consistent-return
        const newSafariTest = () => {
          const tmpName = String(Math.random());
          try {
            const db = window.indexedDB.open(tmpName, 1);
            db.onupgradeneeded = i => {
              let _b;
              const _a = i.target;
              const res =
                _a === null || _a === undefined ? undefined : _a.result;
              try {
                res
                  .createObjectStore('test', {
                    autoIncrement: true,
                  })
                  .put(new Blob());
                __callback(false);
              } catch (e) {
                let message = e;
                _b = e.message;
                if (e instanceof Error) {
                  message = _b !== null && _b !== undefined ? _b : e;
                }
                if (typeof message !== 'string') {
                  return __callback(false);
                }
                const matchesExpectedError = /BlobURLs are not yet supported/.test(
                  message,
                );
                return __callback(matchesExpectedError);
              } finally {
                res.close();
                window.indexedDB.deleteDatabase(tmpName);
              }
            };
          } catch (e) {
            return __callback(false);
          }
        };
        const oldSafariTest = () => {
          const openDB = window.openDatabase;
          const storage = window.localStorage;
          try {
            openDB(null, null, null, null);
          } catch (e) {
            return __callback(true);
          }
          try {
            storage.setItem('test', '1');
            storage.removeItem('test');
          } catch (e) {
            return __callback(true);
          }
          return __callback(false);
        };
        const safariPrivateTest = () => {
          if (navigator.maxTouchPoints !== undefined) {
            newSafariTest();
          } else {
            oldSafariTest();
          }
        };
        /**
         * Chrome
         **/
        const getQuotaLimit = () => {
          const w = window;
          if (
            w.performance !== undefined &&
            w.performance.memory !== undefined &&
            w.performance.memory.jsHeapSizeLimit !== undefined
          ) {
            return performance.memory.jsHeapSizeLimit;
          }
          return 1073741824;
        };
        // >= 76
        const storageQuotaChromePrivateTest = () => {
          navigator.webkitTemporaryStorage.queryUsageAndQuota(
            (usage, quota) => {
              __callback(quota < getQuotaLimit());
            },
            e => {
              reject(
                new Error(
                  `detectIncognito somehow failed to query storage quota: ${
                    e.message
                  }`,
                ),
              );
            },
          );
        };
        // 50 to 75
        const oldChromePrivateTest = () => {
          const fs = window.webkitRequestFileSystem;
          const success = () => {
            __callback(false);
          };
          const error = () => {
            __callback(true);
          };
          fs(0, 1, success, error);
        };
        const chromePrivateTest = () => {
          if (
            self.Promise !== undefined &&
            self.Promise.allSettled !== undefined
          ) {
            storageQuotaChromePrivateTest();
          } else {
            oldChromePrivateTest();
          }
        };
        /**
         * Firefox
         **/
        const firefoxPrivateTest = () => {
          __callback(navigator.serviceWorker === undefined);
        };
        /**
         * MSIE
         **/
        const msiePrivateTest = () => {
          __callback(window.indexedDB === undefined);
        };
        const main = () => {
          if (isSafari()) {
            browserName = 'Safari';
            safariPrivateTest();
          } else if (isChrome()) {
            browserName = identifyChromium();
            chromePrivateTest();
          } else if (isFirefox()) {
            browserName = 'Firefox';
            firefoxPrivateTest();
          } else if (isMSIE()) {
            browserName = 'Internet Explorer';
            msiePrivateTest();
          } else {
            reject(new Error('detectIncognito cannot determine the browser'));
          }
        };
        main();
      });

    const incognitoDetails = await detectIncognito();
    isPrivateMode = incognitoDetails?.isPrivate;
    const browserName = incognitoDetails?.browserName;
    const getSelectedCookiesObj = getSelectedCookies();
    let alertMsg = `
    \n Referrer URL is ${document?.referrer},
    \n Network is ${navigator?.connection?.effectiveType},
    \n Network Speed is ${navigator?.connection?.downlink} Mb/s,
    \n Current URL is ${window?.location?.href},
    \n UserAgent is ${navigator?.userAgent},
    \n isGA loaded -  ${typeof ga === 'function'},
    \n Geo Location is ${JSON.stringify(window?.geoinfo)},
    \n geo country cookie  - ${getCookie('geo_country')},
    \n isPrivateMode - ${isPrivateMode},
    \n Browser Name - ${browserName}
    \n Cookies - ${JSON.stringify(getSelectedCookiesObj)}
    \n IsUserPrimeViaHeader - ${window?.App?.state?.isPrime}
    `;

    switch (calledFrom) {
      case 'PreLoggin':
        alertMsg = `
        \n  ============= TIMESOFINDIALOGS ${calledFrom}============= \n
         ${alertMsg} \n 
         ${JSON.stringify(extraData)}
         `;
        break;

      case 'PostLoggin':
        alertMsg = `
        \n  ============= TIMESOFINDIALOGS ${calledFrom}============= \n
         ${alertMsg} \n 
         ${JSON.stringify(extraData)}
         `;
        break;

      case 'PreLoggout':
        alertMsg = `
       \n  ============= TIMESOFINDIALOGS ${calledFrom}============= \n
        ${alertMsg} \n 
        ${JSON.stringify(extraData)}
        `;
        break;

      case 'PostLoggout':
        alertMsg = `
       \n  ============= TIMESOFINDIALOGS ${calledFrom}============= \n
        ${alertMsg} \n 
        ${JSON.stringify(extraData)}
        `;
        break;

      default:
        alertMsg = `${alertMsg} `;
    }

    const ChatAPIKey =
      'AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0KWNHsfirvee1-OC50ThL-P6j2NlA9bADG3w1P_zsWU%3D';
    const url = `https://chat.googleapis.com/v1/spaces/AAAAdzvHYZ0/messages?key=${ChatAPIKey}`;
    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: alertMsg,
      }),
    };
    const resp = await fetch(url, fetchConfig);
    if (resp.status !== 200) throw new Error(resp.statusText);
  } catch (e) {
    console.log('error in api response', e);
  }
}
